import React from "react";
import { Link } from "react-router-dom";
import LegalLayout, { EmailLink, useLegalContent } from "./LegalLayout";
import { POLICY_EFFECTIVE_DATE } from "./legalConfig";

function formatDate(iso, lang) {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(lang === "ar" ? "ar-EG" : "en-GB", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function Section({ s }) {
  return (
    <section id={s.id} className="nxlg-section" aria-labelledby={`${s.id}-h`}>
      <h2 id={`${s.id}-h`}>{s.title}</h2>
      {s.lead && <p>{s.lead}</p>}
      {s.paragraphs?.map((p, i) => <p key={i}>{p}</p>)}
      {s.table && (
        <dl className="nxlg-data">
          <div className="nxlg-data-head" aria-hidden="true">
            <span>{s.table.head[0]}</span>
            <span>{s.table.head[1]}</span>
          </div>
          {s.table.rows.map(([what, why], i) => (
            <div className="nxlg-data-row" key={i}>
              <dt>{what}</dt>
              <dd>{why}</dd>
            </div>
          ))}
        </dl>
      )}
      {s.bullets && (
        <ul>
          {s.bullets.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      )}
      {s.link && (
        <p>
          <Link to={s.link.to} className="nxlg-inline-link">{s.link.label}</Link>
        </p>
      )}
      {s.email && <EmailLink />}
    </section>
  );
}

export default function PrivacyPolicyPage() {
  const { t } = useLegalContent();
  return (
    <LegalLayout docTitle={t.privacy.docTitle}>
      {({ lang, t: tr }) => (
        <article className="nxlg-doc">
          <h1>{tr.privacy.title}</h1>
          <p className="nxlg-meta">
            {tr.common.lastUpdated}: {formatDate(POLICY_EFFECTIVE_DATE, lang)}
          </p>
          {tr.privacy.intro.map((p, i) => (
            <p key={i} className="nxlg-intro">{p}</p>
          ))}
          <nav className="nxlg-toc" aria-label={tr.privacy.title}>
            <ol>
              {tr.privacy.sections.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`}>{s.title}</a>
                </li>
              ))}
            </ol>
          </nav>
          {tr.privacy.sections.map((s) => <Section key={s.id} s={s} />)}
        </article>
      )}
    </LegalLayout>
  );
}
